import { Link } from 'react-router-dom';
import { Icon } from '../components/Icons';
import { useGiveaway } from '../features/giveaways/GiveawayProvider';
import { requestTrackOfTheDayReward } from '../features/giveaways/giveawayApi';

export default function TrackOfTheDaySlot({ track = null, onPlayTrack }) {
    const { showRewardToken } = useGiveaway();
    if (track) {
        return (
            <section className="bjnt-track-of-day bjnt-track-of-day--active">
                <div className="bjnt-track-of-day__label">
                    Track of the Day
                </div>

                <div className="bjnt-track-of-day__cover">
                    {track.cover ? (
                        <img src={track.cover} alt="" />
                    ) : (
                        <span />
                    )}
                </div>

                <div className="bjnt-track-of-day__content">
                    <h2>{track.title}</h2>

                    <p>{track.artist || 'Unknown Artist'}</p>

                    <div className="bjnt-track-of-day__actions">
                        <button
                            type="button"
                            className="bjnt-home-btn"
                            onClick={async () => {
                                onPlayTrack?.(track);

                                try {
                                    const reward = await requestTrackOfTheDayReward(track.id);

                                    if (reward?.alreadyCollected) {
                                        return;
                                    }

                                    if (!reward?.success || !reward?.token) {
                                        return;
                                    }

                                    showRewardToken(reward.token);

                                } catch (error) {
                                    // silently ignore
                                }
                            }}
                        >
                            <Icon name="play" size={20} />
                            <span>Play Track</span>
                        </button>

                        <Link
                            to={`/track/${track.slug}`}
                            className="bjnt-home-btn bjnt-home-btn--secondary"
                        >
                            View Track
                        </Link>
                    </div>
                </div>

                <div className="bjnt-track-of-day__promo">

                    <strong>You could be next.</strong>

                    <span>
                        Promote your release as Track of the Day.
                    </span>

                    <a
                        href="mailto:advertise@bajantube.com?subject=Track%20of%20the%20Day%20Feature"
                        className="bjnt-track-of-day__promo-btn"
                    >
                        Claim This Spot
                    </a>
                </div>
            </section>
        );
    }

    return (
        <section className="bjnt-track-of-day bjnt-track-of-day--empty">
            <div>
                <p className="bjnt-track-of-day__eyebrow">
                    Feature Slot Available
                </p>

                <h2>Want to be Track of the Day?</h2>

                <p>
                    Put your Crop Over release in front of listeners across
                    Bajantube.
                </p>
            </div>

            <a
                href="mailto:advertise@bajantube.com?subject=Track%20of%20the%20Day%20Feature"
                className="bjnt-home-btn"
            >
                Claim This Spot
            </a>
        </section>
    );
}